import { load as loadPageData } from './components/page-data';
import smoothScrollingAnchors from './components/smooth-scrolling-anchors';
import header from './components/header';
import accordions from './components/accordions';
import galleries from './components/galleries';
import productGalleries from './components/product-galleries';
import tabGroups from './components/tab-groups';
import zoomOverlay from './components/zoom-overlay';
import markup from './components/markup';
import popups from './components/popups';
import * as utils from './utils';
import jqueryPlugins from './jquery-plugins';

log.setDefaultLevel('info');

gsap.config({
    nullTargetWarn: false,
});

window.utils = utils;

window.pageData = loadPageData();

jqueryPlugins.register();

$(function() {
    header.initialize();
    smoothScrollingAnchors.initialize();
    accordions.initialize();
    galleries.initialize();
    productGalleries.initialize();
    tabGroups.initialize();
    zoomOverlay.initialize();
    markup.initialize();
    popups.initialize();
});

